import * as React from "react";
import { getIconContent } from "../../hooks/useGetIconContent";
import type { AppIconProps, AppIconState } from "./AppIcon.types";
import type { ContainerProps } from "../CommonIconTypes.type";
import { slot } from "@fluentui/react-components";

export const useAppIcon = (
  props: AppIconProps,
  ref: React.Ref<HTMLElement>
): AppIconState => {
  const iconName = props.iconName;
  const { iconCode, mergeImageProps, iconClassName } = getIconContent(iconName);

  const containerProps: ContainerProps =
    props["aria-label"] || props["aria-labelledby"] || props.title
      ? {}
      : {
          "aria-hidden": true,
        };

  const accessibleName = props["aria-label"] || props.title || "";

  const addAltName =
    mergeImageProps &&
    typeof iconCode === "object" &&
    typeof iconCode.props === "object";

  const children = addAltName
    ? React.cloneElement(iconCode, { alt: accessibleName })
    : iconCode;

  const root = slot.always(
    { ...props, ref },
    {
      defaultProps: { ref, ...containerProps },
      elementType: "i",
    }
  );

  return {
    iconName,
    iconColor: props.iconColor,
    hideIcon: props.hideIcon,
    flipInRtl: props.flipInRtl,
    disabled: props.disabled,
    shouldFlipIcon: props.shouldFlipIcon,
    components: {
      root: "i",
    },
    root,
    iconClassName,
    children,
  };
};
